"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * mapShipmentLogApiToSdk
 * Maps properties from API to SDK
 * @param {any} apiShipmentLog
 * @returns {ISdkShipmentLog}
 */
exports.mapShipmentLogApiToSdk = function (apiShipmentLog) {
    var timestamp = apiShipmentLog.createdAt;
    return Object.assign({}, apiShipmentLog, { timestamp: timestamp });
};
